"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.installMockedInstanceConnector = exports.installInstanceConnector = void 0;
const createInstances = (instanceList) => {
    return instanceList.reduce((pluginsObject, plugin) => {
        var _a;
        const name = (_a = plugin === null || plugin === void 0 ? void 0 : plugin.settings) === null || _a === void 0 ? void 0 : _a.name;
        if (!name) {
            console.error('Instance name was not found, did you set it with instanceSettings decorator?');
            return { ...pluginsObject };
        }
        return { ...pluginsObject, [name]: plugin };
    }, {});
};
const injectInstancesWithContext = (instances, context) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const [_, value] of Object.entries(instances)) {
        value.setContext(context);
        value.setInstances(instances);
    }
};
function installInstanceConnector(type, instanceList, context) {
    switch (type) {
        case 'Nuxt':
            return {
                install() {
                    const instances = createInstances(instanceList);
                    injectInstancesWithContext(instances, context);
                    return (name) => {
                        return instances[name];
                    };
                },
            };
        case 'Vue':
        default:
            return {
                install(vueImport) {
                    const instances = createInstances(instanceList);
                    injectInstancesWithContext(instances, context);
                    vueImport.prototype.$instanceConnector = (name) => {
                        return instances[name];
                    };
                },
            };
    }
}
exports.installInstanceConnector = installInstanceConnector;
function installMockedInstanceConnector(type) {
    switch (type) {
        case 'Nuxt':
            return {
                install() {
                    return null;
                },
            };
        case 'Vue':
        default:
            return {
                install(vueImport) {
                    vueImport.prototype.$instanceConnector = () => {
                        return null;
                    };
                },
            };
    }
}
exports.installMockedInstanceConnector = installMockedInstanceConnector;
//# sourceMappingURL=installInstanceConnector.js.map